import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["check" ]

  toggle(e) {

    this.checkTargets.forEach(t => {
      if (!t.disabled) t.checked = e.target.checked
    })
  }

}
